import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapLS = () => {
  return (
    <GenericPage frame="https://rsgiskaznu.maps.arcgis.com/apps/mapviewer/index.html?webmap=2a324d5a0f184057bd8401fc0cc2c575" title="Карта современных ландшафтов" tiles={tiles.back('map')} frame_offset={60}/>
  )
}
export default MapLS
